import { useEffect, useState } from "react";
import { api, formatNumber } from "@/lib/api";

export const VentasResumenLine = ({ productoId }) => {
  const [d, setD] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/productos/${productoId}/lotes`)
      .then(({ data }) => { if (!cancelled) setD(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [productoId]);

  if (!d || !d.total_recibido) return null;
  const vendido = (d.total_despachado || 0) + (d.total_reservado || 0);
  return (
    <div className="p-2 bg-muted/40 rounded-md text-xs tabular-nums flex flex-wrap gap-x-3 gap-y-1" data-testid="ventas-resumen-line">
      <span>Inicial <b data-testid="ventas-resumen-inicial">{formatNumber(d.total_recibido)}</b></span>
      <span className="text-rose-600" title={`Despachado ${d.total_despachado} + reservado en pedidos confirmados ${d.total_reservado}`}>
        Vendido <b data-testid="ventas-resumen-vendido">{formatNumber(vendido)}</b>
      </span>
      <span className="text-emerald-700 font-semibold">Disponible <b data-testid="ventas-resumen-disponible">{formatNumber(d.disponible_venta)}</b></span>
    </div>
  );
};
